/**
 * Relatorio Automatico
 */
import {ID, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'

export class RelatorioEntrega extends Resource {
  idResponsavelPK: number = 0

  get $id() {
    return this.idResponsavelPK
  }
  set $id(val) {
    this.idResponsavelPK = val
  }

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  periodoInicial: Date | null = null
  periodoFinal: Date | null = null

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  reset() {
    this.periodoInicial = null
  }

  async getRelatorioEntrega(
    idResponsavel?: string,
    dataInicio?: string,
    dataFim?: string
  ) {
    const baseUrl = '/admin/entregas/relatorio'
    const params = new URLSearchParams()

    if (idResponsavel) {
      params.append('idResponsavel', idResponsavel)
    }
    if (dataInicio) {
      params.append('dataInicio', dataInicio)
    }
    if (dataFim) {
      params.append('dataFim', dataFim)
    }

    const url = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl

    return await Request.get(url, {responseType: 'blob'})
      .name('getRelatorioEntregas')
      .asAny()
      .getResponse()
  }
}
